<template>
  <base-dialog
    :action="onAction"
    :action-name="'Delete'"
    :close="onClose"
    :title="$t('modal.user.title')"
  >
    <template #activator="{ on }">
      <slot name="activator" v-bind="{ on }" />
    </template>

    <template #content>
      <div>
        <p>
          {{ $t("modal.user.options_msg") }}
          <!-- << options >> TODO what is this for ??? -->
          <br />
          <b>{{ $t("modal.user.confirmation_msg") }}</b>
        </p>
      </div>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from "vuex";
import BaseDialog from "@/components/Common/BaseDialog";

export default {
  components: { BaseDialog },
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name: "",
    };
  },
  methods: {
    ...mapActions(["deleteTenantUser"]),
    onClose() {
      this.$emit("close");
    },
    async onAction() {
      const payload = {
        id: this.id,
      };

      await this.deleteTenantUser(payload);

      this.$emit("action", payload);
    },
  },
};
</script>
